import React, { useCallback, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useRemoveWebhook, getUpdateCacheOnRemoveWebhook } from 'src/models/company/Webhooks/hooks';
import { notification, confirm, Button } from 'src/common';
import modalStyles from 'src/common/Modal/index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-light-svg-icons';

interface IProps {
  id: string;
}
export const WebhookDelete: FC<IProps> = props => {
  const { id } = props;
  const { t } = useTranslation();
  const [removeWebhook] = useRemoveWebhook();

  const onDeleteWebhook = useCallback(async () => {
    confirm.confirm({
      title: t('Webhooks.deleteWebhook'),
      content: t('Webhooks.deleteWebhookConfirm'),
      okText: t('Common.delete'),
      cancelText: t('Common.cancel'),
      className: modalStyles.confirmModal,
      centered: true,
      onOk() {
        removeWebhook({
          variables: { id },
          update: getUpdateCacheOnRemoveWebhook(id)
        }).catch(() => {
          notification.error({
            description: t('Common.unknownErrorDesc'),
            message: t('Common.unknownError')
          });
        });
      }
    });
  }, [id, removeWebhook, t]);

  return <Button type={'text'} onClick={onDeleteWebhook} icon={<FontAwesomeIcon icon={faTrash} />} />;
};

export default WebhookDelete;
